(function () {
  var lastTotalCents = null;
  var activeFrame = null;
  var pendingAnimate = false;
  var DURATION = 750;

  // Damped overshoot: the value quickly rises past the target, then falls
  // back and settles with a small, dampening oscillation.
  function dampedOvershoot(t) {
    if (t >= 1) return 1;
    var decay = 5;
    var omega = 2 * Math.PI * 1.3;
    return 1 - Math.exp(-decay * t) * Math.cos(omega * t);
  }

  function formatMoney(cents, symbol, code) {
    var negative = cents < 0;
    var amount = Math.abs(cents);
    var whole = (amount / 100).toFixed(2);
    var parts = whole.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var formatted = symbol + parts.join('.');
    if (code) formatted += ' ' + code;
    return negative ? '-' + formatted : formatted;
  }

  function getTotalEl() {
    return document.querySelector('.tt-cart__totals-value[data-tt-total-cents]');
  }

  function animateTotal(fromCents, toCents, root) {
    if (!root) root = getTotalEl();
    if (!root) return;

    var display = root.querySelector('[data-tt-total-display]') || root;
    var symbol = root.dataset.ttCurrencySymbol || '£';
    var code = root.dataset.ttCurrencyCode || '';

    if (fromCents === toCents) {
      display.textContent = formatMoney(toCents, symbol, code);
      lastTotalCents = toCents;
      return;
    }

    if (activeFrame) cancelAnimationFrame(activeFrame);

    var start = null;

    function frame(now) {
      if (start === null) start = now;
      var t = Math.min(1, (now - start) / DURATION);
      var eased = dampedOvershoot(t);
      var current = Math.round(fromCents + (toCents - fromCents) * eased);
      display.textContent = formatMoney(current, symbol, code);

      if (t < 1) {
        activeFrame = requestAnimationFrame(frame);
      } else {
        activeFrame = null;
        display.textContent = formatMoney(toCents, symbol, code);
        lastTotalCents = toCents;
      }
    }

    activeFrame = requestAnimationFrame(frame);
  }

  function readTargetCents(root) {
    return parseInt(root.dataset.ttTotalCents, 10);
  }

  function syncTotal(animate) {
    var root = getTotalEl();
    if (!root) return;

    var toCents = readTargetCents(root);
    if (isNaN(toCents)) return;

    var display = root.querySelector('[data-tt-total-display]') || root;
    var symbol = root.dataset.ttCurrencySymbol || '£';
    var code = root.dataset.ttCurrencyCode || '';

    if (!animate) {
      display.textContent = formatMoney(toCents, symbol, code);
      lastTotalCents = toCents;
      return;
    }

    var fromCents = lastTotalCents != null ? lastTotalCents : 0;
    animateTotal(fromCents, toCents, root);
  }

  function scheduleSync(animate) {
    requestAnimationFrame(function () {
      syncTotal(animate);
    });
  }

  function initObserver() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || drawer.dataset.ttTotalObserved) return;
    drawer.dataset.ttTotalObserved = 'true';

    var debounceTimer;
    new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        var shouldAnimate = pendingAnimate || lastTotalCents != null;
        pendingAnimate = false;
        scheduleSync(shouldAnimate);
      }, 40);
    }).observe(drawer, { childList: true, subtree: true });
  }

  function init() {
    initObserver();
    scheduleSync(false);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        pendingAnimate = true;
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
